import React, { useContext, useMemo } from 'react'
import {
  InternalChatManagerContext,
  InternalChatOnList,
} from '~/service/InternalChatManager'
import MainContent from '../MainContent'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

const List: React.FC = () => {
  const { chats, loadHook } = useContext(InternalChatManagerContext)

  loadHook()

  const sortChats = useMemo(
    () =>
      chats.sort((a, b) => {
        const userA = window.c.users.find(user => user.id == a.userId)
        const userB = window.c.users.find(user => user.id == b.userId)

        return userA && userB ? userA.name.localeCompare(userB.name) : 0
      }),
    [chats]
  )

  return (
    <>
      <div className="chat-list chat-history-list">
        <MainContent>
          {sortChats.map(chat => (
            <ListItem chat={chat} key={chat.userId} />
          ))}
        </MainContent>
      </div>
    </>
  )
}

type ListItemProps = {
  chat: InternalChatOnList
}

const ListItem: React.FC<ListItemProps> = ({ chat }) => {
  const user = window.c.users.find(user => user.id == chat.userId)

  return (
    <>
      <Link
        to={'/internal-chat/' + chat.userId}
        className={classNames('chat-list-item chat-list-item--internal', {
          'is-active':
            window.location.pathname == '/internal-chat/' + chat.userId,
        })}
      >
        <figure className="chat-list-item-avatar">
          <div
            className={classNames('chat-list-item-avatar-status', {
              'is-online': chat.online,
            })}
          />
          <img src={user?.avatar} />
        </figure>

        <div className="chat-list-item-main">
          <div className="chat-list-item-main-top">
            <div className="chat-list-item-name">{user?.name}</div>
            <div className="chat-list-item-count">
              <div>{chat.unreadCount > 0 ? chat.unreadCount : null}</div>
            </div>
          </div>

          <div className="chat-list-item-message">
            {chat.lastMessage && chat.lastMessage}
          </div>
        </div>
      </Link>
    </>
  )
}

export default List
